import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import SectionHeading from '../../Common/SectionHeading'
import AccordionSection from './AccordionSection'
import InteractionsSection from './InteractionsSection'
import { interactionsList } from './DataSet/MainData' 
import { accordionList } from './DataSet/MainData'

export default function OurDifferentiatorsSection() {
  return (
    <>
        <div className="relative h-full z-0 bg-cover bg-center bg-no-repeat py-8 AccordionBox bg-[#1b5df3]">
            <div className='w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto'>
                <div className="absolute inset-0 bg-[#1b5df3] opacity-70 z-[-1]"></div>
                <SectionHeading
                    customClass="text-white lg:text-center"
                    title="Our Differentiators"
                    
                />
                <div className="grid grid-cols-12 gap-4">
                    <div className="lg:col-span-6 col-span-12">
                        <InteractionsSection data={interactionsList} />
                    </div>
                    <div className="lg:col-span-6 col-span-12">
                        <AccordionSection data={accordionList} />
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
